import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'content-Type': 'application/json'
  })
};
@Injectable()
export class StorageService {
  // addAddressUrl = environment.apiUrl + 'address/add';
  // countUrl = environment.apiUrl + 'address/count';
  // retrieveUrl = environment.apiUrl + 'address/retrieve';

  addAddressUrl = environment.apiUrl + 'storages/storage';
  countUrl = environment.apiUrl + 'storages/count';
  retrieveUrl = environment.apiUrl + 'storages/allStorages';
  constructor(private http: HttpClient) {}

  addAddress(address: string, creator: string): Observable<string> {
    const creatorJSON =
      '{ "address" : ' +
      '"' +
      address +
      '"' +
      ', ' +
      '"creator" : ' +
      '"' +
      creator +
      '"' +
      ' }';

    // console.log(JSON.parse(creator));
    return this.http.post<string>(
      this.addAddressUrl,
      JSON.parse(creatorJSON),
      httpOptions
    );
  }

  count(creator: string): Observable<string> {
    const creatorJSON = '{ "creator" : ' + '"' + creator + '"' + ' }';

    // console.log(JSON.parse(creator));
    return this.http.post<string>(
      this.countUrl,
      JSON.parse(creatorJSON),
      httpOptions
    );
  }

  retrieve(creator: string): Observable<string> {
    const creatorJSON = '{ "creator" : ' + '"' + creator + '"' + ' }';

    // console.log(JSON.parse(creator));
    return this.http.post<string>(
      this.retrieveUrl,
      JSON.parse(creatorJSON),
      httpOptions
    );
  }
}
